module.exports = __webpack_public_path__ + "static/media/0322_IMG_LES_MURS_PNO7_ROUGE_ROSSO_VERTICALE.217b45d8.png";